import React from "react";
import { ArrowUpRight, MessageCircle, Clock } from "lucide-react";
import { waLink } from "../lib/site";

const CTA_MSG =
  "Olá ASHIR GROUP, quero conversar com um especialista sobre crédito estruturado. Podem me atender agora?";

export default function SpecialistCTA() {
  return (
    <section
      id="especialista"
      data-testid="specialist-section"
      className="relative overflow-hidden bg-[#D4AF37]"
    >
      {/* Dark textured overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 20% 30%, rgba(5,7,13,0.55) 0%, transparent 55%), radial-gradient(ellipse at 85% 80%, rgba(5,7,13,0.75) 0%, transparent 60%), linear-gradient(135deg, #D4AF37 0%, #F0CC59 45%, #D4AF37 100%)",
        }}
      />

      {/* Subtle diagonal lines */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #05070D 0px, #05070D 1px, transparent 1px, transparent 22px)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Left — icon + eyebrow */}
          <div className="lg:col-span-2 flex lg:flex-col items-center lg:items-start gap-4">
            <div
              data-testid="specialist-icon"
              className="w-16 h-16 bg-[#05070D] flex items-center justify-center border-2 border-[#05070D]"
            >
              <MessageCircle size={26} strokeWidth={1.6} className="text-[#D4AF37]" />
            </div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#05070D]/70 font-semibold">
              Atendimento direto
            </div>
          </div>

          {/* Center — headline */}
          <div className="lg:col-span-7">
            <h2
              className="font-serif-ag text-[#05070D] text-3xl md:text-4xl lg:text-[2.9rem] xl:text-5xl font-medium leading-[1.06] tracking-[-0.015em] uppercase"
              style={{ letterSpacing: "-0.005em" }}
            >
              Converse agora com um{" "}
              <span className="italic" style={{ fontStyle: "italic" }}>
                especialista
              </span>
              . Podemos ajudar você a obter crédito estruturado rapidamente.
            </h2>

            <div className="mt-5 flex items-center gap-3">
              <div className="w-8 h-px bg-[#05070D]/50" />
              <div className="flex items-center gap-2 text-[10px] md:text-xs text-[#05070D]/75 tracking-[0.14em] uppercase">
                <Clock size={12} strokeWidth={1.8} />
                Comece hoje — obtenha crédito amanhã
                <span className="normal-case tracking-normal text-[#05070D]/55 lowercase">
                  (após análise e due-diligence)
                </span>
              </div>
            </div>
          </div>

          {/* Right — CTA */}
          <div className="lg:col-span-3 flex justify-start lg:justify-end">
            <a
              href={waLink(CTA_MSG)}
              target="_blank"
              rel="noreferrer"
              data-testid="specialist-cta"
              className="group inline-flex items-center gap-3 bg-[#05070D] text-[#D4AF37] px-8 py-5 text-xs md:text-sm tracking-[0.22em] uppercase font-semibold hover:bg-[#0B101A] hover:text-[#F0CC59] transition-all duration-300 shadow-[0_20px_50px_-15px_rgba(5,7,13,0.5)]"
            >
              <MessageCircle size={17} strokeWidth={1.8} />
              Falar Agora
              <ArrowUpRight
                size={16}
                strokeWidth={1.8}
                className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom black stripe with dashes */}
      <div
        className="relative h-2"
        style={{
          background:
            "repeating-linear-gradient(90deg, #05070D 0 20px, transparent 20px 32px)",
        }}
      />
    </section>
  );
}
